import React from 'react'

import { Flex, Text } from 'components/ds'

type Props = {
  title: string
  subtitle?: string
  /** Red flags the subtitle as a limit reached */
  subtitleColor?: 'gray' | 'red'
  emphasised?: boolean
  aside?: React.ReactNode
  children?: React.ReactNode
}

/** Shared layout of a "Your subscription" card row: title and subtitle on the left, aside on the right. */
const SubscriptionRow = ({
  title,
  subtitle,
  subtitleColor = 'gray',
  emphasised,
  aside,
  children,
}: Props): React.ReactNode => (
  <Flex direction="column" gap="4">
    <Flex justify="between" align="start" gap="4">
      <Flex direction="column" gap="1">
        <Text size="2" weight={emphasised ? 'bold' : 'medium'}>
          {title}
        </Text>
        {subtitle && (
          <Text size="1" color={subtitleColor}>
            {subtitle}
          </Text>
        )}
      </Flex>
      {aside}
    </Flex>
    {children}
  </Flex>
)

export default SubscriptionRow
